import React from 'react'
import { IUploadedVideoWQuestionData } from 'hooks/video'
import { graphql } from 'relay-runtime'
import { QuestionAnswerListItem_Question$key } from '__generated__/QuestionAnswerListItem_Question.graphql'
import { useFragment } from 'react-relay'
import { QuestionAnswerListItem_User$key } from '__generated__/QuestionAnswerListItem_User.graphql'
import AnswerListItem from 'components/AnswerListItem'

export interface IQuestionAnswerListItemProps {
  onVideoSaved?: (video: IUploadedVideoWQuestionData) => void
  onError?: (error?: any) => void
  userFragmentRef: QuestionAnswerListItem_User$key
  questionFragmentRef: QuestionAnswerListItem_Question$key
  index: number
  finished?: boolean

  /** @deprecated */
  onAnswerSaved?: () => void
}

function QuestionAnswerListItem(props: IQuestionAnswerListItemProps) {
  const {
    userFragmentRef,
    questionFragmentRef,
    onVideoSaved,
    onAnswerSaved,
    onError,
    index,
    finished = false,
  } = props

  const user = useFragment(graphql`
    fragment QuestionAnswerListItem_User on User {
      configuration {
        videoMaxDuration
        videoMinDuration
      }

      ...AnswerListItem_User
    }
  `, userFragmentRef)

  const question = useFragment<QuestionAnswerListItem_Question$key>(graphql`
    fragment QuestionAnswerListItem_Question on Question {
      id
      defaultMaxDuration
      ...AnswerListItem_Question
    }
  `, questionFragmentRef)

  const defaultMaxDuration = user?.configuration?.videoMaxDuration ?? 60
  // TODO: this does not respect the job's setting for max duration. Re-organize the API to expose the right max duration
  const maxDuration = question?.defaultMaxDuration ? question.defaultMaxDuration * 60 : defaultMaxDuration

  return (
    <AnswerListItem
      userFragmentRef={user}
      index={index}
      questionFragmentRef={question}
      onVideoSaved={onVideoSaved}
      onAnswerSaved={onAnswerSaved}
      key={question?.id}
      onError={onError}
      finished={finished}
      maxDuration={maxDuration}
    />
  )
}

export default React.memo(QuestionAnswerListItem)
